var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6601 0.2337C17.3531 -0.0366005 16.8708 -0.0752756 16.3722 0.13255H16.3713C15.8469 0.351001 1.52653 6.72772 0.943561 6.98825C0.837529 7.02649 -0.088506 7.3852 0.00688135 8.1842C0.092034 8.90458 0.836301 9.20293 0.927185 9.23735L4.56787 10.5315C4.80941 11.3662 5.69983 14.4457 5.89674 15.1036C6.01956 15.5138 6.21975 16.0527 6.5706 16.1636C6.87846 16.2868 7.18468 16.1742 7.38282 16.0127L9.60866 13.8694L13.2019 16.7786L13.2874 16.8317C13.5314 16.9439 13.7652 17 13.9883 17C14.1606 17 14.326 16.9664 14.4841 16.8993C15.0224 16.6698 15.2377 16.1372 15.2603 16.0769L17.9442 1.59413C18.108 0.820627 17.8803 0.427076 17.6601 0.2337ZM7.7787 11.0491L6.55054 14.4491L5.32237 10.1991L14.7383 2.97411L7.7787 11.0491Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/telegram-icon.190daafee9e14d888e458d0ee9f0b108.svg";
export { ForwardRef as ReactComponent };